export default {
    methods: {
        focusInput() {
            if (this.score.toString() === '0') this.score = ''
        },

        blurInput() {
            if (this.score === '' || this.score === undefined || this.score === null) this.score = '0'
        },
    }
}